<template>
  <div>线下组卷</div>
</template>

<script>
export default {
  name: "offline-exam",
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
</style>